export interface DefaultsGroup {
  title: string;
  description: string;
  keys: string[];
}

/** The deal-setup default groups shared by the mock and live Fund defaults pages. */
export const DEAL_DEFAULT_GROUPS: DefaultsGroup[] = [
  {
    title: 'Trust',
    description: 'How new trusts are usually set up.',
    keys: ['fund.entityType', 'fund.trustee', 'fund.currency', 'tax.aiirType', 'registrar.mode'],
  },
  {
    title: 'Deal terms',
    description: 'The usual terms for a new deal.',
    keys: [
      'fund.strategy',
      'fund.basis',
      'fund.frequency',
      'class.partlyPaid',
      'class.fee',
      'offer.min',
      'offer.max',
      'offer.increment',
    ],
  },
  {
    title: 'Unit class',
    description: 'The class every new trust starts with.',
    keys: [
      'class.name',
      'class.code',
      'class.category',
      'class.issuePrice',
      'class.appRounding',
      'class.redRounding',
      'class.unitPrecision',
      'class.pricePrecision',
    ],
  },
  {
    title: 'Unit certificates',
    description: 'Certificate settings for each new class.',
    keys: ['cert.enabled', 'cert.startSeq', 'cert.title', 'cert.terms'],
  },
  {
    title: 'Offers',
    description: 'How a new offer is usually set up.',
    keys: [
      'offer.timezone',
      'offer.closeTime',
      'offer.countdown',
      'offer.useExisting',
      'offer.issueAtClose',
      'offer.notesField',
      'offer.terms',
      'offer.ddReadIm',
      'offer.ddWholesale',
      'offer.ddRisks',
      'offer.branding',
    ],
  },
  {
    title: 'Receiving payments',
    description: 'How investors usually pay their application money in.',
    keys: [
      'offer.collectBank',
      'offer.payEft',
      'offer.payBpay',
      'offer.payDueMode',
      'offer.payDays',
    ],
  },
  {
    title: 'Communications',
    description: 'Which emails go out on their own, and team notifications.',
    keys: [
      'comms.confirmEmail',
      'comms.confirmRelease',
      'comms.reminderRelease',
      'comms.reminderDays',
      'comms.fromName',
      'notify.paymentReceived',
      'notify.dailySummary',
    ],
  },
];
